
















import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class HIVESearchBar extends Vue {
  @Prop(String) public label: string
  @Prop(String) public value: string
  private get getLabel() {
    return this.label
  }

  private get getValue() {
    return this.value
  }

  private checkSubmit(event: Event) {
    if (event && event.keyCode === 13) {
      this.$emit('enter')
    }
  }
}
